/* eslint no-undef: 0, no-console: 0 */

// import log from 'utils/logger'
// import { error } from 'utils/logger'
// import log, { error } from 'utils/logger'

export default function log(...args) {
  // MQTT_JS_DEBUG is used in utils/streaming
  // MQTT_DEBUG is used in reducers/data
  if (process.env.NODE_ENV === 'development' || window.MQTT_DEBUG || window.MQTT_JS_DEBUG) {
    console.log.apply(console, args)
  }
}

export function groupLog(tag, ...args) {
  if (process.env.NODE_ENV === 'development' || window.MQTT_DEBUG || window.MQTT_JS_DEBUG) {
    console.groupCollapsed(tag)
    log(...args)
    console.groupEnd()
  }
}

export function error(...args) {
  console.error.apply(console, args)
}
